module.exports = __webpack_public_path__ + "static/media/agilitycropped.db8e9432.jpg";